import { useDispatch, useSelector } from 'react-redux';
import { editSettingsProp } from 'state/fence/fenceSlice';
import { materials, colorNames } from 'helpers/globals';
import style from './ColorChooser.module.scss';
import SonevaColorSand from 'assets/img/soneva-color-sand.jpg';
import SonevaColorCreamWhite from 'assets/img/soneva-color-cream-white.jpg';
import SonevaColorGray from 'assets/img/soneva-color-gray.jpg';
import SonevaColorAnthracite from 'assets/img/soneva-color-anthracite.jpg';
import SonevaColorSaharaBrown from 'assets/img/soneva-color-sahara-brown.jpg';

const ColorChooser = () => {
  const dispatch = useDispatch();
  const fence = useSelector((state) => state.fence);
  const colors = materials.soneva.colors;

  const isActive = (color) => {
    return fence.settings.color === color;
  };

  const setColorHandler = (color) => {
    dispatch(editSettingsProp({ prop: 'color', value: color }));
  };

  const buttons = [
    {
      name: 'sand',
      image: SonevaColorSand,
      title: colorNames['sand'],
    },
    {
      name: 'creamWhite',
      image: SonevaColorCreamWhite,
      title: colorNames['creamWhite'],
    },
    {
      name: 'gray',
      image: SonevaColorGray,
      title: colorNames['gray'],
    },
    {
      name: 'anthracite',
      image: SonevaColorAnthracite,
      title: colorNames['anthracite'],
    },
    {
      name: 'saharaBrown',
      image: SonevaColorSaharaBrown,
      title: colorNames['saharaBrown'],
    },
  ];

  return (
    <div className={style.colorChooser}>
      <h3 className={style.colorChooser_title}>Színek</h3>

      <ul className={style.colorChooser_list}>
        {buttons.map((button, index) => (
          <li key={index}>
            <button
              type="button"
              className={`${style.colorChooser_btn} ${
                isActive(colors[button.name]) ? style['colorChooser_btn-active'] : ''
              }`}
              onClick={() => setColorHandler(colors[button.name])}
            >
              <figure>
                <img src={button.image} alt="" />
              </figure>
              {button.title}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ColorChooser;
